/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { API_HOSTNAME, API_VERSION_DEFAULT } from '../../app/Api';

export const API_FORM_ADDRESS_SEARCH_PARAM = 'type';
export const API_FORM_ADDRESS_SEARCH =
    `${API_HOSTNAME}/${API_VERSION_DEFAULT}/address/air/search/elements?type={${API_FORM_ADDRESS_SEARCH_PARAM}}`;

export const API_FORM_ADDRESS_STRING = `${API_HOSTNAME}/${API_VERSION_DEFAULT}/address/air/string`;
